export const isEmpty = (value) => {
	if (value === null || value === '' || value === undefined) {
		console.log('return true');
		return true;
	} else {
		return false;
	}
};

export const validateEmail = (email) => {
	const re =
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-ZÀ-žäöüÄÖÜß\-0-9]+\.)+[a-zA-ZÀ-žäöüÄÖÜß]{2,}))$/;
	// /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	return re.test(String(email).toLowerCase());
};
export const validatePhone = (phone) => {
	const regex = /^(?=[a-zA-Z0-9~@#$^*()_+=[\]{}|\\,.?: -]*$)(?!.*[<>'"/;`%])/;

	return regex.test(phone);
};
export const validateName = (name) => {
	const re =
		/^(?=[a-zA-ZÀ-žäöüÄÖÜß0-9~@#$&^*/;`%()_+=[\]{}|\\,.?: -]*$)(?!.*[<>'"])/;
	return re.test(String(name));
};
export const validateScript = (script) => {
	const re =
		/^(?=[a-zA-ZÀ-žäöüÄÖÜß0-9~@#$&\n^*/;`%()_+=[\]{}|\\,.?: -]*$)(?!.*[<>'"])/;
	return re.test(String(script));
};
export const validateSkills = (skills) => {
	const re = /^(?=[a-zA-Z0-9~@#$&^*/;`%()_+=[\]{}|\\,.?: -]*$)(?!.*[<>'"])/;
	return re.test(skills);
};
